import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, Response } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class FcmDataService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  saveFcm(obj) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/users/saveFcmToken`,
      obj
    );
  }
  
}
